import { Pipe, PipeTransform } from '@angular/core';
import { Me } from 'src/lib/services/me.service';

@Pipe({
  name: 'can'
})
export class CanPipe implements PipeTransform {

	transform(me: Me, ...roles: string[]): boolean {
		return me.can(...roles);
	}
}
